import { z } from 'zod';
import { userRole } from './users.js';
export const addAllowlistInput = z.object({
    email: z.string().trim().toLowerCase().pipe(z.string().email()),
    role: userRole.optional(),
});
export const updateAllowlistRoleInput = z.object({
    role: userRole,
});
